export default {
    allDocuments: {},
    showSigner: {},
    reloadIndex: false,
}